export default [
  {
    id: 'en-profile',
    title: 'プロフィール',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'en-address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'skills',
    title: 'スキル',
    previewJumpId: 'skills'
  },
  {
    id: 'license-history',
    title: '免許・資格',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'job-history'
  },
  {
    id: 'pr-message',
    title: '自己PR',
    previewJumpId: 'pr-message'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-button'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'preview-page-01'
  }
]
